export default "__VITE_ASSET__700248aa__"